import { render, staticRenderFns } from "./SearchPageSettings.vue?vue&type=template&id=0b78894a&scoped=true"
import script from "./SearchPageSettings.vue?vue&type=script&lang=js"
export * from "./SearchPageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78894a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b78894a')) {
      api.createRecord('0b78894a', component.options)
    } else {
      api.reload('0b78894a', component.options)
    }
    module.hot.accept("./SearchPageSettings.vue?vue&type=template&id=0b78894a&scoped=true", function () {
      api.rerender('0b78894a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/SearchPageSettings.vue"
export default component.exports